// Legacy published these rates as editable content; a rate change is now a code change.
const RATES_EFFECTIVE_DATE = 'September 21, 2026';
const EFFR = '3.88%';
const TIERS = [
    {min: '$0', max: '$25,000', spread: '4.00%', rate: '7.88%'},
    {min: '$25,000', max: '$50,000', spread: '3.75%', rate: '7.63%'},
    {min: '$50,000', max: '$250,000', spread: '3.25%', rate: '7.13%'},
    {min: '$250,000', max: '$500,000', spread: '3.10%', rate: '6.98%'},
    {min: '$500,000', max: '$1,000,000', spread: '2.85%', rate: '6.73%'},
    {min: '$1,000,000', max: '', spread: '2.35%', rate: '6.23%'},
];

export function MarginBorrowing() {
    return (
        <>
            <p>When you qualify, we offer margin borrowing, enabling you to purchase additional eligible securities (including fractional shares of securities) without depositing additional funds, based on the eligible securities you already have in your eligible account. By borrowing against your securities rather than selling them, you can keep your investment strategy intact and delay capital gains (or losses) resulting from the sale of investments (consult your tax advisor for more details).</p>

            <p>The margin rates for customer accounts are listed below and are effective as of {RATES_EFFECTIVE_DATE}. Margin rates are subject to change without notice.</p>

            <table className="text-center">
                <thead>
                <tr>
                    <th colSpan={2}><i>Margin Tier</i></th>
                    <th colSpan={5}>Effective {RATES_EFFECTIVE_DATE}</th>
                </tr>
                <tr>
                    <th>Min</th>
                    <th>Max</th>
                    <th>EFFR</th>
                    <th>+</th>
                    <th>Spread</th>
                    <th>=</th>
                    <th>Margin Rate*</th>
                </tr>
                </thead>
                <tbody>
                {TIERS.map(tier => (
                    <tr key={tier.min}>
                        <td className="text-right">{tier.min}</td>
                        <td className="text-right">{tier.max}</td>
                        <td>{EFFR}</td>
                        <td>+</td>
                        <td>{tier.spread}</td>
                        <td>=</td>
                        <td>{tier.rate}</td>
                    </tr>
                ))}
                </tbody>
            </table>

            <h2>Key Features</h2>
            <ul>
                <li>Individual, Joint, Trust, and Business accounts are eligible for margin borrowing
                    <ul>
                        <li>Note that only one individual account and one joint account may be margin enabled. Refer to the <a href="/help/margin-borrowing-faq">FAQs</a> for details.</li>
                    </ul>
                </li>
                <li>Publicly traded stocks and ETFs held by us in client brokerage accounts are generally considered eligible securities for margin borrowing</li>
                <li>For an account to be eligible for margin borrowing, it must have a value of at least $2,000, either in cash and/or in eligible securities</li>
                <li>We may lend you up to 50% of the purchase price of eligible securities</li>
                <li>There is no set repayment schedule, as long as you maintain the required equity in your account</li>
            </ul>

            <p>Learn more about <a href="/help/margin-borrowing-faq">margin borrowing</a>.</p>

            <h2>Risks of Margin Borrowing</h2>
            <ul>
                <li>The main risk of margin borrowing is related to decreases in the market value of the securities in your account. If the value of your securities falls significantly, then you will need to add funds or sell securities in your account. Even if you do so, we may still sell assets in your account without notifying you first.</li>
                <li>We encourage you to read our <a href="/help/margin-borrowing-faq">FAQs</a> and the full <a href="/help/margin-disclosure.pdf" target="_blank" rel="noopener noreferrer">FINRA margin disclosure statement</a>, for more information.</li>
            </ul>

            <h2>Margin Interest Rates</h2>
            <ul>
                <li>The annual rate of interest applicable to your account will be computed based on the Effective Federal Funds Rate, which is available on the New York Federal Reserve <a href="https://www.newyorkfed.org/markets/reference-rates/effr" target="_blank" rel="noopener noreferrer">website</a>. Your margin rate will change without prior notice to you, in accordance with changes in the Effective Federal Funds Rate. Please note that while the margin rate you will be charged is based on the Effective Federal Funds Rate, the date that the new margin rate will be applied to your debit balance is the date the updated margin rate is published on this website, which is disclosed above. We will update the rates published to our website soon after a change in the Effective Federal Funds Rate. You will be notified of any change to increase the spread prior to its effective date.</li>
                <li>* The margin rates in the table above are our standard rates (“Standard Rates”). Advisors may negotiate rates for their clients that are different than our Standard Rates. Please contact your advisor to understand the margin rates that will be charged to you. Any negotiated rate may be terminated without prior notice to you and you will be charged an interest rate consistent with the then current Standard Rates.</li>
            </ul>
        </>
    );
}
